import * as Yup from 'yup';

import { normalizePhoneNumber } from './phoneNumber';

export const contactGroupSchemaV2 = Yup.object()
  .shape({
    name: Yup.string().required('Required Field'),
    escalationPhoneNumber: Yup.string().required('Phone number is required').length(10, 'Phone number is required'),
    verifyIdBadge: Yup.boolean(),
    verifyRiderName: Yup.boolean(),
    verifyRiderBirthdate: Yup.boolean(),
  })
  .test(
    'atLeastOneVarificationVariant',
    'At least one verification requirement must be selected',
    (values, context) => {
      const { verifyIdBadge, verifyRiderName, verifyRiderBirthdate } = values;

      if (!(verifyIdBadge || verifyRiderName || verifyRiderBirthdate)) {
        return context.createError({
          path: context.path ? `${context.path}.verifyIdBadge` : 'verifyIdBadge',
          message: 'At least one verification requirement must be selected',
        });
      }

      return true;
    }
  );

export function mustBeMetProtocolValidationSchemaV2() {
  return Yup.object().shape({
    mustBeMetProtocol: Yup.object().when('mustBeMet', {
      is: true,
      then: Yup.object().shape({
        locationProtocol: Yup.string().nullable().required('drop-off procedure is required'),
        authorizedContactGroups: Yup.array()
          .of(contactGroupSchemaV2)
          .min(1, 'At least one contact group is required')
          .test('uniqueGroupNames', 'This group name is already used.', (groups, context) => {
            const duplicates = (groups || []).flatMap((group, index) => {
              const name = group.name?.trim().toLowerCase();
              const hasDuplicate =
                name &&
                groups?.some((other, otherIndex) => otherIndex !== index && other.name?.trim().toLowerCase() === name);

              if (!hasDuplicate) {
                return [];
              }

              return context.createError({
                path: `${context.path}[${index}].name`,
                message: 'This group name is already used.',
              });
            });

            return duplicates.length ? new Yup.ValidationError(duplicates) : true;
          })
          .test('uniqueEscalationNumbers', 'This escalation number is already used.', (groups, context) => {
            const duplicates = (groups || []).flatMap((group, index) => {
              const hasDuplicate = groups?.some(
                (other, otherIndex) =>
                  otherIndex !== index &&
                  !!group.escalationPhoneNumber &&
                  normalizePhoneNumber(other.escalationPhoneNumber || '') ===
                    normalizePhoneNumber(group.escalationPhoneNumber)
              );

              if (!hasDuplicate) {
                return [];
              }

              return context.createError({
                path: `${context.path}[${index}].escalationPhoneNumber`,
                message: 'This escalation number is already used.',
              });
            });

            return duplicates.length ? new Yup.ValidationError(duplicates) : true;
          }),
      }),
    }),
  });
}
